<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-clock :width="22" :height="22" />
        연장근무 시간을 확인해주세요.
      </v-col>
    </v-row>

    <!-- 출근시간 선택 -->
    <v-row class="ma-0">
      <v-col cols="12" class="borderLine-outer pt10">
        <div class="borderLine-wrap d-flex justify-space-between pb-5">
          <span class="borderLine-title d-flex align-self-center">
            출근시간
            <span class="time ml-6">{{ GET_REQ_S_HM }}</span>
          </span>
          <v-btn elevation="0" height="42" @click="clickTimePicker('start')">
            출근시간 변경
          </v-btn>
        </div>

        <!-- 퇴근시간 선택 -->
        <div class="py-3 mt-2 d-flex justify-space-between">
          <span class="borderLine-title d-flex align-self-center">
            퇴근시간
            <span class="time ml-6">{{ GET_REQ_E_HM }}</span>
          </span>
          <v-btn elevation="0" height="42" @click="clickTimePicker('end')">
            퇴근시간 변경
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- 연장근무 시간확인 -->
    <v-row
      class="ma-0 bt-line"
      :class="GET_OTWORK_APPL_GUBUN !== 'A' ? 'bb-line' : ''"
    >
      <v-col cols="12" class="borderLine-outer pt10">
        <div class="py-3 mt-2 d-flex justify-space-between">
          <span class="borderLine-title d-flex align-self-center">
            연장근무
          </span>
          <span class="borderLine-title d-flex align-self-center">
            {{ GET_REQUEST_HOUR || 0 }}시간 ( 휴게 : {{ GET_REST_HOUR }}시간
            제외 )
          </span>
        </div>
      </v-col>
    </v-row>

    <!-- 출퇴근시간 반영여부체크 -->
    <v-row class="ma-0" v-if="GET_OTWORK_APPL_GUBUN === 'A'">
      <v-col cols="12" class="pt-8 pb-5 px-6 bt-line">
        <span class="font-weight-bold">출퇴근시간을 반영하시겠습니까?</span>
        <br />
        <strong>'예'</strong>를 선택하시면 입력한 근무시간으로
        <br />
        <strong>출퇴근시간이 자동 변경</strong> 됩니다
      </v-col>
      <v-col cols="12" class="px-6 py-0 btn-wrap">
        <v-btn-toggle
          borderless
          v-model="inoutYnBtn"
          class="d-flex flex-row btn-toggle"
        >
          <v-btn class="flex-grow-1">예</v-btn>
          <v-btn class="flex-grow-1">아니오</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <!-- 다음버튼 -->
    <next-btn @next="nextStep()"></next-btn>

    <!---------------------------------------------------------------------------->
    <!-- 시작 시간 선택 -->
    <bottom-time-picker
      :flag="sTimePickerFlag"
      :currTime="{ hour, min }"
      @changeTime="setSTime"
    />
    <bottom-time-picker
      :flag="eTimePickerFlag"
      :currTime="{ hour, min }"
      @changeTime="setETime"
    />
  </div>
</template>

<script>
/* 연장근무 시간확인 */
import IconClock from '@/assets/customIcon/IconClock.vue';
import NextBtn from '@/components/application/buttons/AppNextBtn.vue';
import BottomTimePicker from '@/components/application/form/BottomTimePicker.vue';
import routerNames from '@/const/routerConstants';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    sTimePickerFlag: false,
    eTimePickerFlag: false,
    inoutYnBtn: 0,
    hour: '',
    min: '',
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_REQ_S_HM',
      'GET_REQ_E_HM',
      'GET_REQUEST_HOUR',
      'GET_REST_HOUR',
      'GET_OTWORK_APPL_GUBUN',
      'GET_HOL_YN',
      'GET_REQ_TIME_CD',
    ]),

    fetchInoutYn() {
      // 사후 일때만 출퇴근시간 반영
      if (this.GET_OTWORK_APPL_GUBUN === 'B') return 'N';
      else return this.inoutYnBtn === 0 ? 'Y' : 'N';
    },
  },

  methods: {
    ...mapMutations('ELA', [
      'SET_REQ_S_HM',
      'SET_REQ_E_HM',
      'SET_IN_OUT_YN',
      'SET_REST_HOUR',
      'SET_REQUEST_HOUR',
    ]),

    /* 출퇴근시간변경 버튼 클릭시 */
    clickTimePicker(gubun) {
      if (gubun === 'start') {
        this.hour = this.GET_REQ_S_HM.substr(0, 2);
        this.min = this.GET_REQ_S_HM.substr(3, 2);
        this.sTimePickerFlag = !this.sTimePickerFlag;
      } else {
        this.hour = this.GET_REQ_E_HM.substr(0, 2);
        this.min = this.GET_REQ_E_HM.substr(3, 2);
        this.eTimePickerFlag = !this.eTimePickerFlag;
      }
    },

    setSTime(time) {
      let timeStr = time.replaceAll(':', '');
      this.SET_REQ_S_HM(timeStr);
      if (this.GET_REQ_E_HM === '') {
        this.SET_REQ_E_HM(timeStr);
      }
      this.$store.dispatch('ELA/FETCH_OT_WORK_HOUR');
    },

    setETime(time) {
      let timeStr = time.replaceAll(':', '');
      this.SET_REQ_E_HM(timeStr);
      this.$store.dispatch('ELA/FETCH_OT_WORK_HOUR');
    },

    async nextStep() {
      // 신청시간이 1시간 이상이여야함
      if (
        this.GET_REQUEST_HOUR === '0' ||
        this.GET_REQUEST_HOUR === 0 ||
        this.GET_REQUEST_HOUR === ''
      ) {
        alert('신청시간이 없습니다.');
        return false;
      }

      const result = await this.$store.dispatch('ELA/VALIDATE_OT_WORK_DET');
      if (!result) {
        // 신청 불가시 초기화
        this.SET_REQ_S_HM('0000');
        this.SET_REQ_E_HM('0000');
        this.SET_REST_HOUR('0');
        this.SET_REQUEST_HOUR('0');
        return result;
      }

      // 출퇴근시간 반영 여부 값
      this.SET_IN_OUT_YN(this.fetchInoutYn);

      // 휴일근무 && 보상기준=대체휴가
      if (this.GET_HOL_YN === 'Y' && this.GET_REQ_TIME_CD === 'B') {
        this.$router.push(routerNames.SelectAlterDate); // 대체휴가 선택 화면
      } else {
        this.$router.push(routerNames.ExtraOptions); // 추가옵션 확인 화면
      }
    },
  },
  created() {},
  components: {
    IconClock,
    NextBtn,
    BottomTimePicker,
  },
};
</script>

<style>
.picker-group {
  display: flex;
}

.v-btn-toggle.btn-toggle {
  border-radius: 16px;
}
.v-btn-toggle.btn-toggle:not(.v-btn-toggle--dense)
  .v-btn.v-btn.v-size--default {
  padding: 4px;
}
.v-btn-toggle.btn-toggle .v-btn__content {
  color: #777e87;
}
/* active */
.v-btn-toggle.btn-toggle > .v-btn.v-btn--active {
  color: #f5f5f5 !important;
}
.v-btn-toggle.btn-toggle .v-btn.v-item--active.v-btn--active .v-btn__content {
  height: 40px;
  border-radius: 12px;
  background: #ffffff;
  color: #363c43;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 10%);
}
</style>
